module.exports = __webpack_public_path__ + "static/media/undraw_welcome_cats_thqn.0c5a8703.svg";